<script setup lang="ts">
import type { RelicItemType } from '@/types/relic'
import { getRelicName } from '@/core/relic'
import RelicInfo from '../../item/components/RelicInfo.vue'
import { ref } from 'vue'
import { useUserStore } from '@/stores/modules/user'
import { socketEmitAsync } from '@/utils/web-socket'
import { QuestionFilled } from '@element-plus/icons-vue'

const userStore = useUserStore()

const receiveShow = ref(false)
const receiveRelicList = ref<RelicItemType[]>()
function handleBless(count: number = 1) {
  if (userStore.consumables.relicTreasureMap < count) return ElMessage.warning('圣物藏宝图不足')
  ElMessageBox.confirm(`<p class="affix">确定进行寻宝吗？（本次寻宝花费 ${count}<span class="relic">🧩圣物藏宝图</span>）</p>`, '提示', {
    type: 'warning',
    dangerouslyUseHTMLString: true,
    appendTo: 'body',
    confirmButtonClass: 'is-plain',
  })
    .then(async () => {
      const res = await socketEmitAsync<{ relicList: RelicItemType[]; relicBlessTimes: number }>({ type: 'relicBless', data: { count } })
      const { relicList, relicBlessTimes } = res
      userStore.getRelicToBag(relicList)
      userStore.consumables.relicTreasureMap -= count
      userStore.relicBlessTimes = relicBlessTimes

      receiveRelicList.value = relicList
      receiveShow.value = true
    })
    .catch(() => {})
}
</script>

<template>
  <div class="relic-bless">
    <p style="text-align: right; font-size: 14px; margin: 5px 0">🧩 {{ userStore.consumables.relicTreasureMap }}</p>
    <div class="bless-wrap border-wrap">
      <h4 class="affix">
        <span class="relic">高级寻宝</span>
        <div class="help-info">
          <el-popover placement="bottom" width="100%" trigger="click">
            <template #reference>
              <el-icon size="16"><QuestionFilled /></el-icon>
            </template>
            <div class="affix">
              <h4>寻宝说明</h4>
              <p>1. 在圣物藏馆中寻宝您可以获得<span class="relic">圣物</span>奖励。</p>
              <p>
                2. 寻宝无法获得<span class="special">改变攻击元素</span>的圣物，如：<span class="race">火灵球碎片</span>、<span class="legend"
                  >火灵球</span
                >、<span class="antiquity">熔岩之核</span>等。
              </p>
              <p>
                3. 保底时，必定获得<span class="legend">传说</span>圣物。寻宝概率公示：<span class="normal">普通</span> 30%，<span class="race"
                  >稀有</span
                >
                43%，<span class="epic">史诗</span> 20%，<span class="legend">传说</span>
                7%。
              </p>
            </div>
          </el-popover>
        </div>
      </h4>

      <div class="bless-list">
        <div class="bless-item">
          <p>1 圣物藏宝图 / 次</p>
          <p>距离保底次数：{{ 10 - userStore.relicBlessTimes }}</p>
          <el-button type="primary" plain @click="handleBless(1)">寻宝 1次</el-button>
          <el-button type="primary" plain @click="handleBless(10)">寻宝 10次</el-button>
        </div>
      </div>
    </div>

    <el-dialog v-model="receiveShow" width="100%" style="max-width: 500px" destroy-on-close>
      <h2>恭喜获得</h2>

      <div class="btn-wrap" style="max-height: 50vh; overflow: auto">
        <el-row :gutter="10">
          <el-col :span="12" v-for="item of receiveRelicList" :key="item.id">
            <el-popover placement="bottom" width="300px" trigger="click">
              <template #reference>
                <CommonBtn size="small" style="margin-bottom: 5px">
                  <span :class="item.quality">
                    {{ getRelicName(item.relicId, 0) }}
                  </span>
                </CommonBtn>
              </template>
              <RelicInfo :relic-info="item" :show-action="false" />
            </el-popover>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <p style="text-align: center">
          <el-button plain @click="receiveShow = false" size="small">关闭</el-button>
        </p>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.relic-bless {
  margin-bottom: 10px;
  flex-flow: column nowrap;
  h4 {
    display: flex;
    justify-content: center;
    position: relative;
    .help-info {
      position: absolute;
      margin-left: 10px;
      right: 30%;
    }
  }
  .bless-list {
    display: flex;
    justify-content: space-between;
    .bless-item {
      margin: 0 auto;
      display: flex;
      flex-flow: column nowrap;
      width: 60%;
      align-items: center;
      h5 {
        font-size: 15px;
        margin: 10px 0;
      }
      p {
        font-size: 14px;
        margin: 5px 0;
      }
      .el-button {
        margin-left: 0;
        margin-bottom: 5px;
      }
    }
  }
  .btn-wrap > div {
    align-items: flex-start;
    :deep() {
      .el-button:focus,
      .el-button:hover {
        background-color: unset;
      }
    }
  }

  :deep() {
    .war-god {
      .el-select__selected-item {
        span {
          color: var(--el-color-danger);
        }
      }
    }
    .wisdom-god {
      .el-select__selected-item {
        span {
          color: var(--el-color-primary);
        }
      }
    }
    .hunt-god {
      .el-select__selected-item {
        span {
          color: var(--el-color-success);
        }
      }
    }
  }
}
</style>
